import { ReactElement } from 'react'
import usePlanImageCardTool from '@editor/hooks/usePlanImageCardTool'
import usePlanTableTool from '@editor/hooks/usePlanTableTool'
import { selectIsPlanViewSceneCovered, useEditorViewStore } from '@editorStores'
import {
  Toolbar as EditorToolbar,
  ToolbarGroup,
  CommentToolSelect,
  PlanTableToolSelect,
  PlanImageCardToolSelect,
  useAddCommentTool,
} from '@editorComponents'

/**
 * Scene tool bar of the plan view: only the plan drawing tools (comment, table, plan image). The
 * storey controls are deliberately absent — storey and plan are chosen in the page drawer, which
 * drives the scene visibility itself. Hidden while the scene is covered (the "Pläne" tab's PDF
 * preview, or "Lastplan", which has no preview): there is nothing to draw on.
 */
const Toolbar = (): ReactElement | null => {
  const isSceneCovered = useEditorViewStore(selectIsPlanViewSceneCovered)
  const { isActive: isAddCommentActive, toggle: toggleAddComment } = useAddCommentTool()
  const { isActive: isAddPlanTableActive, toggle: toggleAddPlanTable } = usePlanTableTool()
  const { isActive: isAddPlanImageCardActive, toggle: toggleAddPlanImageCard } =
    usePlanImageCardTool()

  if (isSceneCovered) return null

  return (
    <EditorToolbar
      sx={{
        // allow drawing in the scene through the bar’s empty hit area
        pointerEvents: 'none',
      }}
    >
      <ToolbarGroup>
        <CommentToolSelect
          isAddCommentActive={isAddCommentActive}
          onToggleAddComment={toggleAddComment}
        />

        <PlanTableToolSelect
          isAddPlanTableActive={isAddPlanTableActive}
          onToggleAddPlanTable={toggleAddPlanTable}
        />

        <PlanImageCardToolSelect
          isAddPlanImageCardActive={isAddPlanImageCardActive}
          onToggleAddPlanImageCard={toggleAddPlanImageCard}
        />
      </ToolbarGroup>
    </EditorToolbar>
  )
}

export default Toolbar
